<template>
    <div class="company">
        <header>
            <input
                type="text"
                v-model="keyword"
                :placeholder="en?'Search Name of Company': '搜索公司名称'"
            />
        </header>
        <div class="list">
            <ul>
                <li
                    v-for="item in companyList"
                    :key="item.id"
                    class="item"
                    @click="toChoose(item)"
                >
                    <img
                        class="logo"
                        :src="item.logo"
                        alt
                    />
                    <P>
                        {{item.projectName}}
                        <img
                            v-show="select && item._id == select._id"
                            src="http://static.unicornselected.com/983ca150-83cf-11e9-99f9-d3f1e658a550.png"
                            alt
                        />
                    </P>
                </li>
            </ul>
        </div>
        <footer @click="toSet">
            <a class="confirm">{{'添加授予记录' | language}}</a>
        </footer>
    </div>
</template>

<script>
import { HttpClient } from '../../util/http.js';
import Vue from 'vue';
import { toast } from '../../util/alert';
export default {
    data() {
        return {
            list: [],
            projectName: '',
            select: null,
            keyword: '',
        };
    },
    created() {
        this.getCityList();
    },
    computed: {
        companyList() {
            if (!this.keyword) return this.list;
            let regex = new RegExp(
                ['', ...this.keyword.toLowerCase().split(''), ''].join('.*'),
                'i',
            );

            return this.list.filter(it => {
                return ['projectName', 'projectNameEng'].some(k => {
                    return regex.test(it[k]);
                });
            });
        },
        en() {
            return location.pathname.indexOf('/en') == -1 ? '' : '/en';
        },
    },
    methods: {
        async getCityList() {
            const res = await HttpClient.get('/company/select/list');
            this.list = res;
        },

        toSet() {
            if (this.select == null) {
                toast(this.en ? 'Please pick one company' : '请选择一家公司');
                return;
            }
            this.$emit('toAddStock', this.select._id);
        },
        toChoose(item) {
            this.select = item;
        },
    },
};
</script>

<style lang='less' scoped>
* {
    margin: 0;
    padding: 0;
}
.company {
    border-radius: 5px;
    width: 1000px;
    margin: 0 auto;
    box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.1);
    header {
        // width: 100%;
        height: 60px;
        border-bottom: 1px solid #ccc;
        input {
            width: 700px;
            height: 40px;
            border-radius: 25px;
            background-color: #eee;
            border-bottom: none;
            margin: 10px 20px;
            padding-left: 20px;
        }
    }
    .list {
        height: 600px;
        overflow: auto;
        .item {
            display: block;
            height: 50px;
            line-height: 50px;
            padding-left: 500px;
            border-bottom: 1px solid #ccc;
            position: relative;
            .logo {
                left: 450px;
                width: 30px;
                height: 30px;
            }
            p {
                text-align: left;
            }
            img {
                position: absolute;
                right: 30px;
                top: 15px;
            }
        }
    }

    footer {
        height: 50px;
        line-height: 50px;
        display: fixed;
        bottom: 0;
        background-color: #bc242b;
        color: #fff;
    }
}
</style>
